// extracted by mini-css-extract-plugin
export default {"double_input":"styles_double_input__sr2tr"};